<template>
    <div>
        <template>
            <private-fl44-unknown-volume-supplementary-agreement-sign-form-customer v-if="purchase.actions.customer.supplementary_agreement === 'sign'" :purchase="purchase" @refresh="$emit('refresh')" :supplementary-agreement="supplementaryAgreement" />
            <template v-else-if="purchase.actions.customer.supplementary_agreement === 'reply'">
                <b-row>
                    <b-col md="10">
                        <text-header id="atmo-disputes-resolution">Согласование разногласий по дополнительному соглашению</text-header>
                    </b-col>
                </b-row>
                <b-overlay :show="isDataSending" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <text-row-price v-model="purchase.purchase_terms.contract_price" label="Стоимость контракта" compact :label-cols-lg="4" />
                    <form-row-edit-price v-if="supplementaryAgreement.type.id === 'regular'" v-model="formDisagreement.price" :v="$v.formDisagreement.price" label="Стоимость контракта с учетом дополнительного соглашения" :label-cols-lg="4" />
                    <template v-else>
                        <fl44-unknown-volume-supplementary-agreement-termination-specifications-edit-table v-model="formDisagreement.deliverables" :v="$v.formDisagreement.deliverables" />
                        <b-form-invalid-feedback :state="!$v.formDisagreement.deliverables.$invalid" class="my-2" style="padding-left: 5px; padding-right: 5px" v-if="$v.formDisagreement.deliverables.$invalid">{{ specErrorMessage }}</b-form-invalid-feedback>
                        <text-row-price label="Общая стоимость, руб." :value="specSum" :label-cols-lg="4" />
                    </template>
                    <form-row-edit-date label="Дата заключения дополнительного соглашения" v-model="formDisagreement.conclusion_date" :v="$v.formDisagreement.conclusion_date" :min-date="purchase.contract.contract_conclusion_date" :max-date="$now()" :label-cols-lg="4" />
                    <form-row-single-line-document-upload v-model="formDisagreement.attachment" :v="$v.formDisagreement.attachment" title="Новая редакция дополнительного соглашения" :label-cols-lg="4" />
                    <form-row-single-line-document-upload v-model="formDisagreement.disagreement" :v="$v.formDisagreement.disagreement" title="Ответ на протокол разногласий" :label-cols-lg="4" />
                    <form-row-edit-textarea v-model="formDisagreement.comment" :v="$v.formDisagreement.comment" label="Комментарий" :label-cols-lg="4" />
                </b-overlay>
                <b-row>
                    <b-col>
                        <b-overlay :show="isDataSending" opacity="0.6" rounded spinner-small spinner-variant="primary" class="d-inline-block">
                            <b-btn :disabled="!$store.getters.getCanSign || $v.formDisagreement.$invalid" class="mr-2 my-2" variant="custom-green" @click="showDisagreementModal = true">Подписать и отправить ответ на протокол разногласий</b-btn>
                        </b-overlay>
                        <fl44-unknown-volume-customer-sign-decline-supplementary-agreement-button :purchase="purchase" :supplementary-agreement="supplementaryAgreement" class="mb-2" @refresh="$emit('refresh')" />
                    </b-col>
                </b-row>
                <template v-if="!$store.getters.getCanSign">
                    <span v-if="$store.getters.getLoginType === 'cert'" class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Для действия требуется загрузить/заменить МЧД на странице: <router-link :to="{ name: 'CabinetUserProfile' }" class="green-link">Данные учетной записи</router-link></span>
                    <span v-else class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Подписание возможно только при авторизации при помощи ЭЦП</span>
                </template>
                <sign-file-modal
                    v-if="formDisagreement.disagreement"
                    :attachment="formDisagreement.disagreement"
                    :show="showDisagreementModal"
                    :is-sending="isDataSending"
                    title="Отправка подписанного ответа на протокол разногласий"
                    @close="showDisagreementModal = false"
                    @submit="storeSignedDisagreement" />
            </template>
            <fl44-unknown-volume-customer-sign-decline-supplementary-agreement-button v-else-if="purchase.actions.customer.supplementary_agreement === 'wait'" :purchase="purchase" :supplementary-agreement="supplementaryAgreement" class="mb-2" @refresh="$emit('refresh')" />
        </template>
    </div>
</template>

<script>
import { maxValue, minValue, required, requiredIf } from 'vuelidate/lib/validators';
import { getCertificate } from 'crypto-pro';
import FileDownload from 'js-file-download';
import PrivateFl44UnknownVolumeSupplementaryAgreementSignFormCustomer from '@/components/products/fl44-unknown-volume/partials/private-fl44-unknown-volume-supplementary-agreement-sign-form-customer.vue';
import cloneDeep from 'lodash.clonedeep';
import Fl44UnknownVolumeSupplementaryAgreementTerminationSpecificationsEditTable from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-supplementary-agreement-termination-specifications-edit-table.vue';
import roundToTwoDecimals from '@lib/js/src/misc/roundToTwoDecimals';
import Fl44UnknownVolumeCustomerSignDeclineSupplementaryAgreementButton from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-customer-sign-decline-supplementary-agreement-button.vue';

export default {
    name: 'private-fl44-unknown-volume-supplementary-agreement-customer-block',
    components: {
        Fl44UnknownVolumeCustomerSignDeclineSupplementaryAgreementButton,
        Fl44UnknownVolumeSupplementaryAgreementTerminationSpecificationsEditTable,
        PrivateFl44UnknownVolumeSupplementaryAgreementSignFormCustomer
    },
    props: {
        purchase: {
            type: Object,
            required: true
        },
        supplementaryAgreement: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showDisagreementModal: false,
            form: {
                attachment: null
            },
            formDisagreement: {
                conclusion_date: null,
                price: 0,
                attachment: null,
                disagreement: null,
                comment: '',
                deliverables: []
            },
            isDataSending: false,
            priceLimit: 0
        };
    },
    validations() {
        const contractPrice = this.purchase.purchase_terms.contract_price;
        const maxPrice = this.purchase.purchase_terms.order_type.price_limit;
        const maxVal = Math.min(contractPrice + contractPrice * 0.1, maxPrice);
        const minVal = this.supplementaryAgreement.type.id === 'regular' ? contractPrice - contractPrice * 0.1 : 0;
        return {
            form: {
                attachment: {
                    required
                }
            },
            formDisagreement: {
                conclusion_date: {
                    required
                },
                price: {
                    required: requiredIf(() => this.supplementaryAgreement.type.id === 'regular'),
                    minValue: minValue(minVal),
                    maxValue: maxValue(maxVal)
                },
                deliverables: {
                    required: requiredIf(() => this.supplementaryAgreement.type.id === 'termination'),
                    priceLimit() {
                        return this.specSum <= this.priceLimit;
                    },
                    $each: {
                        ktru_item: {
                            id: { required }
                        },
                        amount: { required, minValue: minValue(0) },
                        minAmount(item) {
                            return item.amount >= item.min_amount;
                        }
                    }
                },
                attachment: {
                    required
                },
                disagreement: {
                    required
                },
                comment: {
                    required
                }
            }
        };
    },
    mounted() {
        this.fillData();
    },
    methods: {
        fillData() {
            if (this.purchase.actions.customer.supplementary_agreement === 'reply') {
                this.formDisagreement.conclusion_date = this.supplementaryAgreement.conclusion_date;
                this.formDisagreement.price = this.supplementaryAgreement.price;
                if (this.supplementaryAgreement.type.id === 'termination') {
                    this.formDisagreement.deliverables = cloneDeep(this.supplementaryAgreement.deliverables);
                    this.priceLimit = this.purchase.contract.actual_price;
                }
            }
        },
        async send() {
            this.isDataSending = true;
            if (await this.$api.products.fl44UnknownVolume.contracts.store(this.purchase.id, this.form.attachment)) {
                this.$emit('refresh', null);
            }
            this.isDataSending = false;
        },
        async storeSignedDisagreement(signature) {
            this.isDataSending = true;
            const data = {
                certificate: await getCertificate(this.$store.getters.getCurrentThumbprint),
                type: this.supplementaryAgreement.type.id,
                price: this.supplementaryAgreement.type.id === 'termination' ? this.specSum : this.formDisagreement.price,
                conclusion_date: this.formDisagreement.conclusion_date,
                deliverables:
                    this.supplementaryAgreement.type.id === 'termination'
                        ? this.formDisagreement.deliverables.map((deliverable) => {
                              return {
                                  purchase_deliverable_id: deliverable.id,
                                  ktru_item_id: deliverable.ktru_item_id,
                                  amount: deliverable.amount,
                                  price: deliverable.price
                              };
                          })
                        : null,
                comment: this.formDisagreement.comment,
                attachment_id: this.formDisagreement.attachment.id,
                is_importable: this.formDisagreement.attachment.is_importable,
                signed_attachment: {
                    id: this.formDisagreement.disagreement.id,
                    md5: signature.signature
                }
            };
            const disagreementId = this.supplementaryAgreement.supplementary_agreement_disagreements.find((disagreement) => !disagreement.customer).id;
            await this.$api.products.fl44UnknownVolume.supplementaryAgreements
                .storeSignedDisagreement(this.purchase.id, this.purchase.contract.id, this.supplementaryAgreement.id, 'customer', data, disagreementId)
                .then((result) => {
                    if (result) {
                        this.showDisagreementModal = false;
                        this.$emit('refresh', this.$route.hash !== '#atmo-contract-annexes' ? '#atmo-contract-annexes' : null);
                    }
                })
                .finally(() => {
                    this.isDataSending = false;
                });
        },
        downloadZip() {
            this.$api.products.fl223.contracts
                .downloadZip(this.purchase.id, this.purchase.contract.id, this.purchase.contract.contract_files.find((file) => !file.is_archived).contract_attachment.id)
                .then((response) => {
                    FileDownload(response.data, this.purchase.contract.zip_name);
                })
                .catch((error) => {
                    this.showError(error);
                });
        },
        downloadPdf() {
            this.$api.products.fl223.contracts
                .downloadPrintForm(this.purchase.id, this.purchase.contract.id, this.purchase.contract.contract_files.find((file) => !file.is_archived).contract_attachment.id)
                .then((response) => {
                    FileDownload(response.data, this.purchase.contract.pdf_name);
                })
                .catch((error) => {
                    this.showError(error);
                });
        }
    },
    computed: {
        specSum() {
            return roundToTwoDecimals(
                this.formDisagreement.deliverables.reduce((sum, item) => {
                    return (sum += roundToTwoDecimals(item.amount * item.price));
                }, 0)
            );
        },
        specErrorMessage() {
            const deliverables = Object.values(this.$v.formDisagreement.deliverables.$each.$iter);
            if (deliverables.some((e) => e.amount.$invalid)) return 'У одной или более позиций в таблице спецификации не заполнено поле "Количество фактическое"';
            if (!this.$v.formDisagreement.deliverables.priceLimit) return `Сумма по ДС о расторжении не должна превышать сумму контракта / ДС (${this.$formatPrice(this.priceLimit)} руб.)`;
            return '';
        }
    }
};
</script>
